import { createNlsMiddleware, keymap, pathmap, userstate } from 'lcc-state';

// make generated .d.ts file valid
// eslint-disable-next-line @typescript-eslint/no-unused-vars
import { DNode, WNodeFactory, WidgetProperties } from '@dojo/framework/core/interfaces';
// eslint-disable-next-line @typescript-eslint/no-unused-vars
import { DefaultChildrenWNodeFactory, I18nProperties } from '@dojo/framework/core/interfaces';
import { createICacheMiddleware } from '@dojo/framework/core/middleware/icache';
import { theme } from '@dojo/framework/core/middleware/theme';
// eslint-disable-next-line @typescript-eslint/no-unused-vars
import { ThemeProperties } from '@dojo/framework/core/middleware/theme';
import { create, v, w } from '@dojo/framework/core/vdom';
import { formatAriaProperties } from '@dojo/widgets/common/util';
import { Tooltip } from '@dojo/widgets/tooltip';
import { Keys } from '@holmescorp/common';
import { delay } from '@holmescorp/common';

import css from '../css/backview.m.css';

interface BackViewIcache {
	ttopen: boolean;
	ttTitle: string;
}

export interface BackViewProperties {
	captureSelected?: (v: () => void) => void;
	overrideSelected?: () => void;
	overrideTitle?: string;
}

const nls = createNlsMiddleware('settings');
const icache = createICacheMiddleware<BackViewIcache>();
const factory = create({ theme, icache, userstate, nls }).properties<BackViewProperties>();

export const BackView = factory(({ middleware: { theme, icache, userstate, nls }, properties }) => {
	const selected = () => {
		const { get, path } = userstate;
		const location = get(path('location'));
		const [, explore, , , topicgroup, topic] = location.split('/');
		const inExplore = explore !== undefined && explore === 'explore';
		/*
		const parent = inExplore
			? topic !== undefined
				? topicgroup
				: topicgroup !== undefined
				? topicset
				: null
			: null;
		*/
		const parent = inExplore ? (topic !== undefined ? topicgroup : null) : null;
		const view =
			parent !== null
				? () => {
						const { path } = keymap.get(parent)!;
						return pathmap.get(path)!.view;
				  }
				: inExplore
				? () => pathmap.get('/explore')!.view
				: () => () => {
						window.history.back();
				  };
		view()();
	};

	const themeCss = theme.classes(css);
	const {
		messages: { back_title = 'Back' },
		format
	} = nls();

	const { captureSelected, overrideSelected, overrideTitle } = properties();
	captureSelected && captureSelected(selected);

	const ttActive = () => icache.set('ttopen', true);

	const ttHidden = () => icache.set('ttopen', false);

	document.addEventListener('keydown', (event) => {
		if (event.key == Keys.Esc || event.key == Keys.Escape) {
			if (icache.getOrSet('ttopen', false)) {
				icache.set('ttopen', false);
			}
		}
	});

	icache.getOrSet('ttTitle', async (): Promise<any> => {
		await delay(50);
		const { get, path } = userstate;
		const location = get(path('location'));
		const [, , , topicset, ,] = location.split('/');
		try {
			const { path: keyPath } = keymap.get(topicset)!;
			const { topic } = pathmap.get(keyPath)!;
			let title;
			if (topic.topicset.attributes) {
				title = topic.topicset.attributes.title as string;
			}
			return title;
		} catch (error) {
			console.info(error);
		}
	});

	const toolTipTitle = (): string => {
		const title = icache.get('ttTitle');
		if (overrideTitle) {
			return overrideTitle;
		}
		if (title) {
			try {
				return format('back_to', { title });
			} catch (error) {
				console.error(`Missing DynLS key 'back_to'`);
			}
		}
		return back_title;
	};

	const displayTitle = toolTipTitle();
	return v(
		'div',
		{
			classes: [themeCss.root],
			role: 'button',
			tabIndex: 0,
			...formatAriaProperties({ label: displayTitle || 'Go Back', describedby: 'back-tooltip' }),
			onmouseover: ttActive,
			onmouseout: ttHidden,
			onfocus: ttActive,
			onblur: ttHidden,
			onclick: (event) => {
				event.stopImmediatePropagation();
				overrideSelected ? overrideSelected() : selected();
			},
			onkeydown: (event) => {
				switch (event.key) {
					case Keys.Enter:
					case Keys.Space:
					case Keys.Spacebar:
						event.preventDefault();
						overrideSelected ? overrideSelected() : selected();
				}
			}
		},
		[
			w(
				Tooltip,
				{
					open: icache.getOrSet('ttopen', false),
					orientation: 'bottom'
				},
				[
					{
						content: v('span', { id: 'back-tooltip' }, [displayTitle]),
						trigger: v('div', {}, [
							v('span', {}, [displayTitle]),
							v('i', {
								classes: ['fa', 'fa-lg', 'fa-angle-double-left']
							})
						])
					}
				]
			)
		]
	);
});
